/* eslint-disable no-restricted-globals */
/* eslint-disable no-underscore-dangle */
import Vue from 'vue'
// import router from 'vue-router'

// axios
import axios from 'axios'
// import createAuthRefreshInterceptor from 'axios-auth-refresh'

import store from '@/store/index'
// import router from '@/router'

// import router from '@/router/index'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 600000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

const currentExecutingRequests = {}
const exceptionUrls = ['user/appointment/bookings/department/find', 'user/inventory/inventory-request/department/find',
  'user/purchasing/purchase-request/department/find', 'user/operation/service-form/department/find', 'user/operation/service-request/department/find',
  'user/purchasing/vendor-list/department/find', 'user/purchasing/vendor-payments/department/find', 'user/appointment/bookings/find',
  'user/inventory/inventory-request/find', 'user/purchasing/purchase-request/find', 'user/operation/service-form/find', 'user/operation/service-request/find',
  'user/purchasing/vendor-list/find', 'user/purchasing/vendor-payments/find', 'user/budget/find/budgeted', 'user/budget/find/non-budgeted',
  'user/appointments/bookings/daily', 'user/inventory/inventory-requests/status', 'user/inventory/inventory-requests/stores',
  'user/appointments/bookings/monthly', 'user/purchasing/po/status', 'user/purchasing/prf/pending-status', 'user/purchasing/qcf/status',
  'user/operation/service-form/age', 'user/operation/service-form/status', 'user/operation/service-request/age', 'user/operation/service-request/awaiting-approval',
  'user/operation/service-request/quarterly-payment-status', 'user/operation/service-request/pending/thirty-days', 'user/operation/service-request/pending/today',
  'customer/files/attachment/upload', 'customer/customers/attachment/upload', 'customer/invoices/attachment/upload', 'customer/receipts/attachment/upload',
  'customer/agents/attachment/upload', 'budget/budget/allocation/upload/new-file', 'purchase/ncf/upload/new-file', 'purchase/purchase-request/upload/new-file',
  'inventory/inventory-request/respond-with/store-and-item-and-ir', 'operation/service-requests/get-recipient/from-block', 'operation/work-flows/task/find-block',
  'operation/work-flows/task/data-source', 'budget/budget/find']

Vue.prototype.$http.interceptors.request.use(
  config => {
    if (currentExecutingRequests[config.url] && !exceptionUrls.includes(config.url)) {
      const source = currentExecutingRequests[config.url]
      delete currentExecutingRequests[config.url]
      source.cancel()
    }

    store.commit('appConfig/UPDATE_LOADER', true)
    const accessToken = store.state.auth.token
    if (accessToken) {
      // eslint-disable-next-line no-param-reassign
      config.headers = { Authorization: `Bearer ${accessToken}`, ...config.headers }
    }

    const cancelToken = axios.CancelToken
    const source = cancelToken.source()
    // eslint-disable-next-line no-param-reassign
    config.cancelToken = source.token
    currentExecutingRequests[config.url] = source

    return config
  },
  error => Promise.reject(error),
)

const retryOriginalRequest = (milliseconds, originalRequest) => new Promise(resolve => {
  setTimeout(() => resolve(axiosIns(originalRequest)), milliseconds)
})

// let retried = false
// eslint-disable-next-line arrow-body-style
axiosIns.interceptors.response.use(response => {
  if (!store.state.appConfig.continuousLoader) {
    store.commit('appConfig/UPDATE_LOADER', false)
  }
  if (currentExecutingRequests[response.config.url]) {
    delete currentExecutingRequests[response.config.url]
  }
  return Promise.resolve(response)
}, async error => {
  if (axios.isCancel(error)) {
    return new Promise(() => {})
  }
  const { config, response: { status } } = error
  const originalRequest = config

  store.commit('appConfig/UPDATE_LOADER', false)

  if (status === 401) {
    if (originalRequest.url !== 'refresh-token' && !originalRequest._retry) {
      originalRequest._retry = true
      await store
        .dispatch('auth/refreshToken')
        .then(res => {
          originalRequest.headers.Authorization = `Bearer ${res.data.accessToken}`
        })
      return retryOriginalRequest(1000, originalRequest)
    }
    store
      .dispatch('auth/unauthorizedLogout')
    location.href = '/login'
    return Promise.reject(error.response)
  }

  if (currentExecutingRequests[originalRequest.url]) {
    delete currentExecutingRequests[originalRequest.url]
  }

  return Promise.reject(error.response)
})

export default axiosIns
